import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../Context";


export default class FProduct extends Component {
  render() {
    const { id, title, img, price, inCart } = this.props.product;
    return (
      <ProductWrapper className="col-9 mx-auto col-md-6 col-lg-3 my-3">
        <div className="card ">
          <ProductConsumer>
            {(value) => (
              <div className="img-container p-5"
              onClick={()=>{
                value.handleDetail1(id);
               }}
              >
                <Link to="/ProductDetail">
                  <img src={img} alt="product-img" className="card-img-top" />
                </Link>
                <button
                  className="cart-btn"
                  disabled={inCart ? true : false}
                  onClick={() => {
                    value.addToCart1(id);
                    value.openModal(id);
                    
                  }}
                >
                  {inCart ? "inCart" : "add to cart"}
                </button>
              </div>
            )}
          </ProductConsumer>

          {/* {car footer } */}
          <div className="card-footer d-flex justify-content-between" style={{backgroundColor:'#32046e', color:'#fff'}}>
            <p className="align-self-center mb-0">{title}</p>
            <h6 className="text-blue font-italic mb-0">
              <span className="mr-1">$</span>
              {price}
            </h6>
          </div>
        </div>
        
      </ProductWrapper>
      
    );
  }
}
// here we can easily find the mesh-up data value by adding this prop value//


const ProductWrapper = styled.div`
  .card {
    border-color: transparent;
    transition: all 1s linear;
  }
  .card-footer {
    background: transparent;
    border-top: transparent;
    transition: all 1s linear;
  }
  &:hover {
    .card {
      border: 0.04rem solid rgba(0, 0, 0, 0.2);
      box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.2);
    }
    .card-footer {
      background: rgba(247, 247, 247);
    }
  }
  .img-container {
    position: relative;
    overflow: hidden;
  }
  .card-img-top {
    transition: all 1s linear;
  }
  .img-container:hover .card-img-top {
    transform: scale(1.2);
  }
  .cart-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.2rem 0.4rem;
    background: var(--lightBlue);
    border: none;
    color: var(--mainWhite);
    border-radius: 0.5rem 0 0 0;
    transform: translate(100%, 100%);
    transition: all 1s linear;
  }
  .img-container:hover .cart-btn {
    transform: translate(0, 0);
  }
  .cart-btn:hover {
    color: var(--mainBlue);
    pointer: cursor;
  }
`;
